import { useTranslation } from "react-i18next"

import { EmailVerificationPageViewProps } from "../EmailVerificationPageView"
import { PostEmailVerificationPageModel } from "../PostEmailVerificationPage"

export function usePostEmailVerificationPageViewModel({
  navigateToHomepage,
  verificationFailed
}: PostEmailVerificationPageModel): EmailVerificationPageViewProps {
  const { t } = useTranslation()

  if (verificationFailed) {
    return {
      headline: t("PostEmailVerificationPage.VerificationFailed.Headline"),
      subText: t("PostEmailVerificationPage.VerificationFailed.Subtext"),
      navigate: navigateToHomepage
    }
  }

  return {
    headline: t("PostEmailVerificationPage.Headline"),
    subText: t("PostEmailVerificationPage.Subtext"),
    navigate: navigateToHomepage
  }
}
